import api from './api';
import { history } from '../history';

export const authenticate = async (user) => {
  try {
    const response = await api.post("/sessions", {
      username: user.email,
      password: user.password
    });
    if(response.data) {
      var loggedInUser;
      loggedInUser = response.data
    
      localStorage.setItem('id', response.data.id);
      localStorage.setItem('username', user.email);
      localStorage.setItem('password', user.password);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('language', 'pt');
    
      return true;
    } else {
      history.replace('/pages/login', null);
      localStorage.clear();
      return false;
    }
  } catch (error) {
    history.replace('/pages/login', null);
    localStorage.clear();
    return false;
  }
}